module.exports = __webpack_public_path__ + "img/172625_male_user_icon.4ae0b2c5.svg";